import { gql } from "@apollo/client";

import { PAYMENT_TERMINAL_FRAGMENT } from "./fragments";

export const PAYMENT_TERMINALS_QUERY = gql`
  ${PAYMENT_TERMINAL_FRAGMENT}
  query PaymentTerminals(
    $skip: Int
    $take: Int
    $filters: PaymentTerminalFilterInput
    $orderBy: [PaymentTerminalOrderByInput!]
  ) {
    paymentTerminals(
      skip: $skip
      take: $take
      filters: $filters
      orderBy: $orderBy
    ) {
      nodes {
        ...PaymentTerminal
      }
      count
    }
  }
`;
